module.exports = __webpack_public_path__ + "img/distrimed-banner.90f04bd1.jpg";